const chapterColorCode = {
    "ทั้งหมด": "#ffffff",
    "บททั่วไป": "#c32148",
    "พระมหากษัตริย์": "#cc474b",
    "สิทธิและเสรีภาพของปวงชนชาวไทย": "#ff7f49",
    "หน้าที่ของปวงชนชาวไทย": "#ffae42",
    "หน้าที่ของรัฐ": "#fed85d",
    "แนวนโยบายแห่งรัฐ": "#d9e650",
    "รัฐสภา": "#afe313",
    "คณะรัฐมนตรี": "#63b76c",
    "การขัดกันแห่งผลประโยชน์": "#1ab385",
    "ศาล": "#30bfbf",
    "ศาลรัฐธรรมนูญ": "#339acc",
    "องค์กรอิสระ": "#4f69c6",
    "องค์กรอัยการ": "#6456b7",
    "การปกครองส่วนท้องถิ่น": "#6b3fa0",
    "การแก้ไขเพิ่มเติมรัฐธรรมนูญ": "#c154c1",
    "การปฏิรูปประเทศ": "#e667ce",
    "บทเฉพาะกาล": "#da3287",
}

export default chapterColorCode;
